import { useEffect } from 'react';

/**
 * Hook to handle referral code from URL parameter and set it as a cookie
 * Checks for 'fsrc' query parameter in the current URL and stores it in a cookie with 30-day expiration
 * Reads directly from window.location.search to capture the code even if redirects occur
 */
export const useReferralCode = () => {
  useEffect(() => {
    // Read directly from window.location.search to get the original URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const fsrc = urlParams.get('fsrc');
    if (fsrc) {
      // Set cookie with 30 days expiration
      const expirationDate = new Date();
      expirationDate.setTime(expirationDate.getTime() + 30 * 24 * 60 * 60 * 1000);
      document.cookie = `fsrc=${fsrc}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
    }
  }, []); // Run only once on mount
};
